module.exports = __webpack_public_path__ + "img/icon-create-account-black.fca5ba5e.svg";